import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../services/api.service';
import { CommonEventService } from '../services/common-event.service';
import { DomSanitizer,SafeHtml } from '@angular/platform-browser';
import * as $ from 'jquery';

@Component({
  selector: 'app-order-review',
  templateUrl: './order-review.component.html',
  styleUrls: ['./order-review.component.css']
})
export class OrderReviewComponent {
  total_turntime=0;
  total_total=0;
  total_without_shipping=0;
  pcbTotal = 0;
  pcbAssemblyTotal = 0;
  componentTotal = 0;
  pcbTax = 0;
  assemblyTax = 0;
  componentTax = 0;
  orderTotal: any;
  specDetails = [];
  partdata={};
  pcbPartDataSpecs :any =[];
  isHidden = true;
  fabTurnTimeDisplay:any;
  assTurnTimeDisplay:any;
  layerValToDisplay:any;
  pcbSubTotal = 0;
  assemblySubTotal = 0;
  componentSubTotal = 0;
  numOfBomItemsCharging : any;
  savedPartDataIndBoardXDim : any;
  savedPartDataIndBoardYDim : any;
  flowActivityId:any='';

  constructor(private router: Router, public apiService:ApiService,public commonService : CommonEventService,private sanitizer: DomSanitizer) {
    localStorage.setItem('apiSerDataObj','')
    localStorage.setItem('commonDataObj','')
    localStorage.setItem('apDtId','')
  }
  ngOnInit(): void {
    this.commonService.restrictRefreshButton();
    this.commonService.formattingCurrentDateTime();
    var orderReviewData={
      "pageVisited":"Date:  "+this.commonService.commonMainObj.formattedDate+" " +"Time:"+this.commonService.commonMainObj.formattedTime
    }
    this.flowActivityId = this.commonService.commonMainObj.backToPrevPageActivityId != '' ? this.commonService.commonMainObj.backToPrevPageActivityId:this.commonService.commonMainObj.fileId;
    // this.apiService.updateDetailsToDashboard(this.flowActivityId,orderReviewData,'ReviewConfirmOrderPage').subscribe((resDatas)=>{
    // // console.log("updateDetailsToDashboard",resDatails);
    // })
    this.total_total=0;
    this.total_without_shipping = 0;
    this.total_turntime = 0;
    if(this.commonService.commonMainObj.selectedLayerVal > 1 ){
      this.layerValToDisplay = this.commonService.commonMainObj.selectedLayerVal  + ' Layers';
    }else{
      this.layerValToDisplay = this.commonService.commonMainObj.selectedLayerVal  + ' Layer';
    } 
    this.savedPartDataIndBoardXDim = this.commonService.commonMainObj.indBoardXDim > this.commonService.commonMainObj.indBoardYDim ? this.commonService.commonMainObj.indBoardXDim :this.commonService.commonMainObj.indBoardYDim;
    this.savedPartDataIndBoardYDim = this.commonService.commonMainObj.indBoardXDim < this.commonService.commonMainObj.indBoardYDim ? this.commonService.commonMainObj.indBoardXDim :this.commonService.commonMainObj.indBoardYDim;
    this.commonService.commonMainObj.savedBoardDimensions = this.savedPartDataIndBoardXDim +' x '+this.savedPartDataIndBoardYDim+'(inches)';

    if(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems){
      for(var i=0; i < this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems.length; i++){
        if( this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[i].quantity!=null && this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[i].unitPrice!=null ){
          this.total_total +=  ( this.to_Num(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[i].quantity) * this.to_Float(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[i].unitPrice));
          this.total_without_shipping +=  ( this.to_Num(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[i].quantity) * this.to_Float(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[i].unitPrice));
          
          if ( this.commonService.commonMainObj.electricalTesting=="No" ){ 

          }else {
            this.total_total += this.to_Float( this.commonService.commonMainObj.electricalTestingPriceVal );
            this.total_without_shipping += this.to_Float( this.commonService.commonMainObj.electricalTestingPriceVal );
          }
        }
        if(this.commonService.commonMainObj.taxablePrice){
          this.total_total += this.to_Float(this.commonService.commonMainObj.taxablePrice);
          this.total_without_shipping += this.to_Float(this.commonService.commonMainObj.taxablePrice);
        }
      }
      if (this.commonService.commonMainObj.shippingCost!=null && this.commonService.commonMainObj.shippingCost!=""){
        this.total_total += this.to_Float( this.commonService.commonMainObj.shippingCost );
      }
      this.total_total =  this.to_Float(  this.total_total.toFixed(2) );
    }
    if(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems){
      let Total = 0;
      if(this.commonService.commonMainObj.taxableRate != null && this.commonService.commonMainObj.taxableRate != ""){
        this.pcbTax = (this.to_Float(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].subTotal) - this.to_Float(this.commonService.commonMainObj.pcbPromoDiscount ? this.commonService.commonMainObj.pcbPromoDiscount : 0.0)) * this.to_Float(this.commonService.commonMainObj.taxableRate) / 100;
      }else{
        this.pcbTax = 0.00;
      }
      this.total_turntime+=this.to_Num( this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].turntime );
      this.pcbSubTotal = (this.to_Float(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].subTotal) - this.to_Float(this.commonService.commonMainObj.pcbPromoDiscount ? this.commonService.commonMainObj.pcbPromoDiscount : 0.0));
      this.pcbTotal = (this.to_Float(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].subTotal) - this.to_Float(this.commonService.commonMainObj.pcbPromoDiscount ? this.commonService.commonMainObj.pcbPromoDiscount : 0.0)) + this.to_Float(this.pcbTax);
      // console.log("this.pcbTax ",this.pcbTax );
      this.pcbTotal = parseFloat(this.pcbTotal.toFixed(2));
      // console.log("this.pcbTotal",this.pcbTotal);
      if(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems.length > 1){
        if(this.commonService.commonMainObj.taxableRate != null && this.commonService.commonMainObj.taxableRate != ""){
          this.assemblyTax = (this.to_Float(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1].subTotal) - this.to_Float(this.commonService.commonMainObj.assemblyPromoDiscount ? this.commonService.commonMainObj.assemblyPromoDiscount : 0.0)) * this.to_Float(this.commonService.commonMainObj.taxableRate) / 100;
        }else{
          this.assemblyTax = 0.00;
        }
        this.total_turntime+=this.to_Num( this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1].turntime );
        this.assemblySubTotal = (this.to_Float(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1].subTotal) - this.to_Float(this.commonService.commonMainObj.assemblyPromoDiscount ? this.commonService.commonMainObj.assemblyPromoDiscount : 0.0));
        this.pcbAssemblyTotal = (this.to_Float(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1].subTotal) - this.to_Float(this.commonService.commonMainObj.assemblyPromoDiscount ? this.commonService.commonMainObj.assemblyPromoDiscount : 0.0)) + this.to_Float(this.assemblyTax);
        this.pcbAssemblyTotal = parseFloat(this.pcbAssemblyTotal.toFixed(2));
        
        if(this.commonService.commonMainObj.taxableRate != null && this.commonService.commonMainObj.taxableRate != ""){
          this.componentTax = (this.to_Float(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[2].subTotal) - this.to_Float(this.commonService.commonMainObj.componentPromoDiscount ? this.commonService.commonMainObj.componentPromoDiscount : 0.0)) * this.to_Float(this.commonService.commonMainObj.taxableRate) / 100;
        }else{
          //IF THERE IS NO TAX PRICE THEN SUB-TOTAL IS THE componentTotal
          this.componentTotal = this.to_Float(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[2].subTotal);
        }
        this.componentTotal = (this.to_Float(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[2].subTotal) - this.to_Float(this.commonService.commonMainObj.componentPromoDiscount ? this.commonService.commonMainObj.componentPromoDiscount : 0.0)) + this.to_Float(this.componentTax);
        this.componentSubTotal = (this.to_Float(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[2].subTotal) - this.to_Float(this.commonService.commonMainObj.componentPromoDiscount ? this.commonService.commonMainObj.componentPromoDiscount : 0.0))

        this.componentTotal = parseFloat(this.componentTotal.toFixed(2));
        this.componentSubTotal = parseFloat(this.componentSubTotal.toFixed(2));
      }
      //Checking the order is PCB+Assembly or only PCB BASED ON THAT CALCULATING THE TOTAL
      if(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems.length > 1){
        Total = this.pcbTotal + this.pcbAssemblyTotal + this.componentTotal;
      }else{
        Total = this.pcbTotal;
      }
      if(this.commonService.commonMainObj.shippingCost != null && this.commonService.commonMainObj.shippingCost != ""){
        this.orderTotal = Total + this.to_Float(this.commonService.commonMainObj.shippingCost);
        this.orderTotal = parseFloat(this.orderTotal.toFixed(2));

        // this.orderTotal = Math.floor((Total + this.to_Float(this.commonService.commonMainObj.shippingCost)) * 100) / 100;
      }else{
        this.orderTotal = parseFloat(Total.toFixed(2));
        // this.orderTotal = Math.floor(Total * 100) / 100;
      }
      this.commonService.commonMainObj.orderPlacedData.orderTotal = this.orderTotal;
    }
    var qinput:any ={};
    for(var k in this.commonService.commonMainObj.pcbPartData['products']){
      for(var k1 in this.commonService.commonMainObj.pcbPartData['products'][k]['quoteInputGroups']){
        for(var k2 in this.commonService.commonMainObj.pcbPartData['products'][k]['quoteInputGroups'][k1]['quoteInputs']){
          if (qinput[this.commonService.commonMainObj.pcbPartData['products'][k]['quoteInputGroups'][k1]['quoteInputs'][k2]['inputName']] == undefined) {
            qinput[this.commonService.commonMainObj.pcbPartData['products'][k]['quoteInputGroups'][k1]['quoteInputs'][k2]['inputName']] = [];
            qinput[this.commonService.commonMainObj.pcbPartData['products'][k]['quoteInputGroups'][k1]['quoteInputs'][k2]['inputName']].push({'iName': this.commonService.commonMainObj.pcbPartData['products'][k]['quoteInputGroups'][k1]['quoteInputs'][k2]['inputName'],'dName': this.commonService.commonMainObj.pcbPartData['products'][k]['quoteInputGroups'][k1]['quoteInputs'][k2]['displayName']});
          }
        }
      }
    }
    // console.log("qinput",qinput);
    // console.log("this.commonService.commonMainObj.pcbFinalQuotedata",this.commonService.commonMainObj.pcbFinalQuotedata);
    var dataValue;
    let keysToBeRemoved = ["counterBore","counterSink","edgePlating","controlledDielectric","electricalTesting"];
    let finalSavedPcbPartData = this.DeleteMyKeys(this.commonService.commonMainObj.pcbFinalQuotedata.savedPcbPartData,keysToBeRemoved);
    // console.log("finalSavedPcbPartData",finalSavedPcbPartData);
    for(var t in this.commonService.commonMainObj.pcbFinalQuotedata.savedPcbPartData){
      for(var qi in qinput){
        for(var pd in qinput[qi]){
          if (qinput[qi][pd]['iName'] == t) {
            if(this.commonService.commonMainObj.pcbFinalQuotedata.savedPcbPartData[t] == null){
              dataValue = "-";
            }else{
              dataValue = this.commonService.commonMainObj.pcbFinalQuotedata.savedPcbPartData[t];
            }
            if(qinput[qi][pd]['dName'] == "Min. Hole Size"){
              dataValue  = this.commonService.commonMainObj.minHoleSizeSelected;
            }
            if(qinput[qi][pd]['dName'] == "Surface Finish"){
              dataValue  = this.commonService.commonMainObj.surfaceFinish;
            }
            if(qinput[qi][pd]['dName'] == "Min. Space"){
              dataValue  = this.commonService.commonMainObj.minSpaceSelected;
            }
            if(qinput[qi][pd]['dName'] == "Min. Trace"){
              dataValue  = this.commonService.commonMainObj.minTraceSelected;
            }
            if(qinput[qi][pd]['dName'] == "Inner layer Min. Space"){
              dataValue  = this.commonService.commonMainObj.minInnerSpaceSelected?this.commonService.commonMainObj.minInnerSpaceSelected:'' ;
            }
            if(qinput[qi][pd]['dName'] == "Inner layer Min. Trace"){
              dataValue  = this.commonService.commonMainObj.minInnerTraceSelected?this.commonService.commonMainObj.minInnerTraceSelected:'';
            }
            if(qinput[qi][pd]['dName'] == "Allow RoHS Marking"){
              dataValue  = this.commonService.commonMainObj.boardDetailsDataObj.roHSMarking;
            }
            if(qinput[qi][pd]['iName'] == "indBoardXDim"){
              qinput[qi][pd]['dName'] = "Individual Board Dimension X (inches)";
            }
            if(qinput[qi][pd]['iName'] == "indBoardYDim"){
              qinput[qi][pd]['dName'] = "Individual Board Dimension Y (inches)";
            }
            if(qinput[qi][pd]['iName'] == "arrayXDim"){
              qinput[qi][pd]['dName'] = "Array Dimension X (inches)";
            }
            if(qinput[qi][pd]['iName'] == "arrayYDim"){
              qinput[qi][pd]['dName'] = "Array Dimension Y (inches)";
            }
            if(qinput[qi][pd]['iName'] == "silkScreenSides"){
              qinput[qi][pd]['dName'] = "Silk Screen Sides";
              dataValue  = this.commonService.commonMainObj.boardDetailsDataObj.silkScreenSides?this.commonService.commonMainObj.boardDetailsDataObj.silkScreenSides:'-';
            }
            if(qinput[qi][pd]['iName'] == "silkScreenColor"){
              qinput[qi][pd]['dName'] = "Silk Screen Color";
              dataValue  = this.commonService.commonMainObj.boardDetailsDataObj.silkScreenColor?this.commonService.commonMainObj.boardDetailsDataObj.silkScreenColor:'-';
            }
            if(qinput[qi][pd]['iName'] == "solderMaskColor"){
              qinput[qi][pd]['dName'] = "Solder Mask Color";
              dataValue  = this.commonService.commonMainObj.boardDetailsDataObj.solderMaskColor?this.commonService.commonMainObj.boardDetailsDataObj.solderMaskColor:'-';
            }
            if(qinput[qi][pd]['iName'] == "solderMaskFinish"){
              qinput[qi][pd]['dName'] = "Solder Mask Finish";
              dataValue  = this.commonService.commonMainObj.boardDetailsDataObj.solderMaskFinish?this.commonService.commonMainObj.boardDetailsDataObj.solderMaskFinish:'-';
            }
            if(qinput[qi][pd]['iName'] == "solderMaskSides"){
              qinput[qi][pd]['dName'] = "Solder Mask Sides";
              dataValue  = this.commonService.commonMainObj.boardDetailsDataObj.solderMaskSides?this.commonService.commonMainObj.boardDetailsDataObj.solderMaskSides:'-';
            }
            if(qinput[qi][pd]['iName'] == "solderMaskType"){
              qinput[qi][pd]['dName'] = "Solder Mask Type";
              dataValue  = this.commonService.commonMainObj.boardDetailsDataObj.solderMaskType?this.commonService.commonMainObj.boardDetailsDataObj.solderMaskType:'-';
            }
            this.pcbPartDataSpecs.push({'dname': qinput[qi][pd]['dName'],'sname': t,'value': dataValue})
            if(this.pcbPartDataSpecs.length == 1){
              if(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].turntime > 1){
                this.pcbPartDataSpecs.push({'dname':'PCB turn-time','value':this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].turntime + ' Day(s)'})
              }else{
                this.pcbPartDataSpecs.push({'dname':'PCB turn-time','value':this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].turntime + ' Day'})
              }
             
            }
            if(this.pcbPartDataSpecs.length == 26){
              this.pcbPartDataSpecs.push({'dname':'Solder Mask Sides','value':this.commonService.commonMainObj.boardDetailsDataObj.solderMaskSides?this.commonService.commonMainObj.boardDetailsDataObj.solderMaskSides:'-'})
            }
            if(this.commonService.commonMainObj.boardDetailsDataObj.innerLyrFinishCopper){
              if(this.pcbPartDataSpecs.length == 17){
                this.pcbPartDataSpecs.push({'dname':'Inner layer Copper Weight','value':this.commonService.commonMainObj.boardDetailsDataObj.innerLyrFinishCopper})
              }
            }
            // if(this.pcbPartDataSpecs.length == 34){
            //   this.pcbPartDataSpecs.push({'dname':'Silk Screen Method','value':this.commonService.commonMainObj.boardDetailsDataObj.silkScreen?this.commonService.commonMainObj.boardDetailsDataObj.silkScreenMethod:'-'})
            // }
           
           
          }
        }
      }
    }
    this.pcbPartDataSpecs.push({'dname':'Controlled impedance','value':this.commonService.commonMainObj.boardDetailsDataObj.controlledImpedance});
    this.pcbPartDataSpecs.push({'dname':'Internal Slots or Internal Cutouts?','value':this.commonService.commonMainObj.boardDetailsDataObj.slotsCutouts})
    if(this.commonService.commonMainObj.fileUploadedData.boardParam.counterSink == 'Yes'){
      this.pcbPartDataSpecs.push({'dname':'Counter Sink','value':this.commonService.commonMainObj.boardDetailsDataObj.counterSink});
    }
    // console.log("pcbSpecs",this.pcbPartDataSpecs);

  if(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].turntime  > 1){
    this.fabTurnTimeDisplay = this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].turntime + ' Days';
  }else{
    this.fabTurnTimeDisplay = this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[0].turntime + ' Day';
  }
  if(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1]){
    if(this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1].turntime  > 1){
      this.assTurnTimeDisplay = this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1].turntime + ' Days';
    }else{
      this.assTurnTimeDisplay = this.commonService.commonMainObj.pcbFinalQuotedata.pcbFinalQuoteDetails.quoteItems[1].turntime + ' Day';
    }
    this.commonService.commonMainObj.assemblySides = this.commonService.commonMainObj.assemblySides == '1 side'?'One side':'Two sides';
  }

  this.numOfBomItemsCharging = this.commonService.commonMainObj.finalBomDataToPurchase?.okayToBuy?.title.split(' ')[3];
    
  this.commonService.restrictBrowserButtons();
  }

  ngOnDestroy() {
    this.commonService.destroyRefreshEvent();
  }
  
  specDetailsHide(){
    return this.isHidden = !this.isHidden
  }

  // checkSessionPlaceOrder(){
  //   if(this.apiService.encUrlData != localStorage.getItem('encData')){
  //     this.commonService.alertCall('Alert!!','Your session is expired please login and do the flow from starting');
  //     this.commonService.goBack();
  //   }else{
  //     this.apiService.getUserDataSession(this.apiService.encUrlData).subscribe((resData: any)=>{
  //       if(resData && resData.status == "SESSION_FOUND"){
  //         this.goToStatusPage();
  //       }else{
  //         this.commonService.alertCall('Alert!!','Your session is expired please login and do the flow from starting');
  //         this.commonService.goBack();
  //       }
  //     },err=>{
  //       this.commonService.alertCall('Alert!!','Something went wrong');
  //     });
  //   }
    
  // }
  DeleteMyKeys(myObj:any, array:any){
    for (let index = 0; index < array.length; index++) {
      delete myObj[array[index]];
  }
  return myObj;
  }

  goToStatusPage(){
    this.commonService.sessionPortalLoad();
    this.commonService.loadingShow();
    setTimeout(()=>{
      this.commonService.sessionPortalLoad();
      this.commonService.loadingHide();
      this.apiService.checkUserSessionApi().subscribe((data: any)=>{
        if(data.status == 1){
          this.goToStatusPageSessionChecked();
        }
      },error =>{
        console.log('Error in checking user session', error);   
      })
    },2000);
  }

  goToStatusPageSessionChecked(){
    this.commonService.issuesListObjFn();
    var placeOrderObj:any = {}
    placeOrderObj.placeOrder = {
      "areComponentCanNotWashed": this.commonService.commonMainObj.aqueousSelectOption =="Yes"?'1736':'1737',
      "billingAddressLine1": this.apiService.apiMainObj.selectedBillingAddress.addressLine1,
      "billingAddressLine2": this.apiService.apiMainObj.selectedBillingAddress.addressLine2?this.apiService.apiMainObj.selectedBillingAddress.addressLine2:'',
      "billingCity": this.apiService.apiMainObj.selectedBillingAddress.city,
      "billingContactCompany": this.apiService.apiMainObj.selectedBillingAddress.companyName?this.apiService.apiMainObj.selectedBillingAddress.companyName:'',
      "billingContactEmail": this.apiService.apiMainObj.selectedBillingAddress.email?this.apiService.apiMainObj.selectedBillingAddress.email:'',
      "billingContactFirstName": this.apiService.apiMainObj.selectedBillingAddress.firstName?this.apiService.apiMainObj.selectedBillingAddress.firstName:'',
      "billingContactLastName": this.apiService.apiMainObj.selectedBillingAddress.lastName?this.apiService.apiMainObj.selectedBillingAddress.lastName:'',
      "billingContactPhone": this.apiService.apiMainObj.selectedBillingAddress.phoneNumber?this.apiService.apiMainObj.selectedBillingAddress.phoneNumber:'',
      "billingCountry": this.apiService.apiMainObj.selectedBillingAddress.country?this.apiService.apiMainObj.selectedBillingAddress.country:'',
      "billingState": this.apiService.apiMainObj.selectedBillingAddress.state?this.apiService.apiMainObj.selectedBillingAddress.state:'',
      "billingZip": this.apiService.apiMainObj.selectedBillingAddress.zip?this.apiService.apiMainObj.selectedBillingAddress.zip:'',
      "bomSpecialInstructions": "No",
      "channelOrderNumber": "301",
      "contactPersonName24Hour": "",
      "contactPhoneNumber24Hour": "",
      "customerEmail": this.commonService.commonMainObj.email,
      "designFileName": this.commonService.commonMainObj.uploadedFilesData.filename,
      "designerAddressLine1": this.apiService.apiMainObj.selectedDesignerAddress.addressLine1,
      "designerAddressLine2": this.apiService.apiMainObj.selectedDesignerAddress.addressLine2?this.apiService.apiMainObj.selectedDesignerAddress.addressLine2:'',
      "designerCity": this.apiService.apiMainObj.selectedDesignerAddress.city?this.apiService.apiMainObj.selectedDesignerAddress.city:'',
      "designerContactCompany":this.apiService.apiMainObj.selectedDesignerAddress.companyName?this.apiService.apiMainObj.selectedDesignerAddress.companyName:'',
      "designerContactEmail": this.apiService.apiMainObj.selectedDesignerAddress.email?this.apiService.apiMainObj.selectedDesignerAddress.email:'',
      "designerContactFirstName":this.apiService.apiMainObj.selectedDesignerAddress.firstName?this.apiService.apiMainObj.selectedDesignerAddress.firstName:'',
      "designerContactLastName": this.apiService.apiMainObj.selectedDesignerAddress.lastName?this.apiService.apiMainObj.selectedDesignerAddress.lastName:'',
      "designerContactPhone": this.apiService.apiMainObj.selectedDesignerAddress.phoneNumber?this.apiService.apiMainObj.selectedDesignerAddress.phoneNumber:'',
      "designerCountry": this.apiService.apiMainObj.selectedDesignerAddress.country?this.apiService.apiMainObj.selectedDesignerAddress.country:'',
      "designerState": this.apiService.apiMainObj.selectedDesignerAddress.state?this.apiService.apiMainObj.selectedDesignerAddress.state:'',
      "designerZip": this.apiService.apiMainObj.selectedDesignerAddress.zip?this.apiService.apiMainObj.selectedDesignerAddress.zip:'',
      "isElectricalTest":this.commonService.commonMainObj.electricalTesting == "Yes"?'Y':'N',
      "iwillSupplyPcbAs": "0",
      "pcbComingFrom": "0",
      "pcbReceiveDate": "",
      "projectID": "",
      "promoCode": this.commonService.commonMainObj.promoCode != '' ? this.commonService.commonMainObj.promoCode:"",
      "referencePONumber": "",
      "resaleFileByteArray": "",
      "resaleFileName": "",
      "resaleNumber":this.commonService.commonMainObj.isNotAuthChecked?'':this.commonService.commonMainObj.resaleNumber,
      "shipAssembledBoard": "",
      "shippingAccountNumber": this.commonService.commonMainObj.shippingAccountNumber?this.commonService.commonMainObj.shippingAccountNumber:'',
      "shippingAddressLine1": this.apiService.apiMainObj.selectedShippingAddress.addressLine1?this.apiService.apiMainObj.selectedShippingAddress.addressLine1:'',
      "shippingAddressLine2": this.apiService.apiMainObj.selectedShippingAddress.addressLine2?this.apiService.apiMainObj.selectedShippingAddress.addressLine2:'',
      "shippingCity": this.apiService.apiMainObj.selectedShippingAddress.city?this.apiService.apiMainObj.selectedShippingAddress.city:'',
      "shippingContactCompany": this.apiService.apiMainObj.selectedShippingAddress.companyName?this.apiService.apiMainObj.selectedShippingAddress.companyName:'',
      "shippingContactEmail": this.apiService.apiMainObj.selectedShippingAddress.email?this.apiService.apiMainObj.selectedShippingAddress.email:'',
      "shippingContactFirstName": this.apiService.apiMainObj.selectedShippingAddress.firstName?this.apiService.apiMainObj.selectedShippingAddress.firstName:'',
      "shippingContactLastName": this.apiService.apiMainObj.selectedShippingAddress.lastName?this.apiService.apiMainObj.selectedShippingAddress.lastName:'',
      "shippingContactPhone": this.apiService.apiMainObj.selectedShippingAddress.phoneNumber?this.apiService.apiMainObj.selectedShippingAddress.phoneNumber:'',
      "shippingCountry": this.apiService.apiMainObj.selectedShippingAddress.country?this.apiService.apiMainObj.selectedShippingAddress.country:'',
      "shippingMethod": this.commonService.commonMainObj.shippingMethod?this.commonService.commonMainObj.shippingMethod:'',
      "shippingNotes": this.commonService.commonMainObj.shippingNotes?this.commonService.commonMainObj.shippingNotes:'',
      "shippingState": this.apiService.apiMainObj.selectedShippingAddress.state?this.apiService.apiMainObj.selectedShippingAddress.state:'',
      "shippingZip": this.apiService.apiMainObj.selectedShippingAddress.zip?this.apiService.apiMainObj.selectedShippingAddress.zip:'',
      "sierraPCBToolNo": "",
      "specifyWhichCompCanNotWashed": this.commonService.commonMainObj.listOfMpnsSelected?this.commonService.commonMainObj.listOfMpnsSelected.toString():'',
      "taxExemptCertNumber":this.commonService.commonMainObj.isNotAuthChecked?'':this.commonService.commonMainObj.taxExemptCertiNumber?this.commonService.commonMainObj.taxExemptCertiNumber:'' ,
      "taxExemptOutsideCalifornia": this.commonService.commonMainObj.isNotAuthChecked?'':this.commonService.commonMainObj.taxExemptOutsideCalifornia?this.commonService.commonMainObj.taxExemptOutsideCalifornia:'',
      "taxable": this.commonService.commonMainObj.isNotAuthChecked?'':this.commonService.commonMainObj.taxable?"1":"0",
      "whenComponentWillArrive": ""
    };
    placeOrderObj.creditCardDetails = {
      "creditCardExpirationDate": !this.commonService.commonMainObj.isNotAuthChecked?this.commonService.commonMainObj.selectedCreditCard.expirydate:'',
      "creditCardHolderName": !this.commonService.commonMainObj.isNotAuthChecked?this.commonService.commonMainObj.selectedCreditCard.name:'',
      "creditCardNumber": !this.commonService.commonMainObj.isNotAuthChecked?this.commonService.commonMainObj.selectedCreditCard.cardnumber:'',
      "creditCardSecurityCode": !this.commonService.commonMainObj.isNotAuthChecked?this.commonService.commonMainObj.cardCvvNumber:'',
      "creditCardType": !this.commonService.commonMainObj.isNotAuthChecked?this.commonService.commonMainObj.selectedCreditCard.cardtype:''
    }
    placeOrderObj.purchasingPersonDetails = {
      "paymentPending" : this.commonService.commonMainObj.purchasingPersonDetails.paymentPending == true?'1':"0",
      "firstName": this.commonService.commonMainObj.isNotAuthChecked?this.commonService.commonMainObj.purchasingPersonDetails.firstName:'',
      "lastName": this.commonService.commonMainObj.isNotAuthChecked?this.commonService.commonMainObj.purchasingPersonDetails.lastName:'',
      "email": this.commonService.commonMainObj.isNotAuthChecked?this.commonService.commonMainObj.purchasingPersonDetails.email:'',
      "remark": this.commonService.commonMainObj.isNotAuthChecked?this.commonService.commonMainObj.purchasingPersonDetails.remarks:'NA',
    }
    placeOrderObj.placeOrder['issueDetailsList'] = this.commonService.commonMainObj.fabIssuesListArray;
    placeOrderObj.placeOrder['bomIssueDetailsList'] = this.commonService.commonMainObj.bomIssuesListArray;
    // var formData = new FormData();
    //due to OFP-344 commected below line
    //formData.append('file', this.commonService.commonMainObj.file);
    // formData.append('placeOrder', JSON.stringify(placeOrder));
    // formData.append('creditCardDetails',JSON.stringify(creditCardDetails));
    // formData.append('purchasingPersonDetails', JSON.stringify(purchasingPersonDetails));
    // if(this.commonService.commonMainObj.isNotAuthChecked){
    //   formData.append('placeOrder', JSON.stringify(purchasingPersonDetails));
    // }else{
    //   formData.append('creditCardDetails',JSON.stringify(creditCardDetails));
    // }
    placeOrderObj.s3FieldId = (this.commonService.commonMainObj.s3FileName.split('.').slice(0, -1).join('.'))
    placeOrderObj.fileName = this.commonService.commonMainObj.uploadedFileName
    this.commonService.loadingShow();
    this.apiService.placeOrder(placeOrderObj).subscribe((data:any)=>{
      if(data){
        this.commonService.loadingHide();
        this.commonService.commonMainObj.orderPlacedData = data;
        var orderPlacedObj={
          "orderId": this.commonService.commonMainObj.orderPlacedData.orderNumber
        }
        // this.apiService.updateDetailsToDashboard(this.flowActivityId,orderPlacedObj,'ReviewConfirmOrderPage').subscribe((resDatas)=>{
        //   // console.log("updateDetailsToDashboard",resDatails);
        //   });
        this.router.navigateByUrl('/orderstatus');
        // console.log("pplace data",data);
      }
    },error => {
      this.commonService.loadingHide();
      console.log("Error in placing order",error);
    });
    
  }

  cc_format(cardNUm:any){
    return( "XXXX-XXXX-XXXX-" + (cardNUm.toString()).substring(cardNUm.toString().length - (this.commonService.commonMainObj.selectedCreditCard.cardtype=='2'? 3 : 4))  );
  }

  to_Num(x:any){
    return( parseInt(x,10) );
  }
  to_Float(x:any){
    return( parseFloat(x) );
  }

  goToOrderDetailsPage(){
    if(this.commonService.commonMainObj.userSessionMemberId != null){
      this.commonService.sessionPortalLoad();
      setTimeout(()=>{
        this.apiService.checkUserSessionApi().subscribe((data: any)=>{
          if(data.status == 1){
            this.commonService.commonMainObj.backToOrderDetails = true;
            this.router.navigateByUrl('/orderDetails');
          }
        },error =>{
          console.log('Error in checking user session', error);     
        })
      },800);   
    }else{
      this.commonService.commonMainObj.backToOrderDetails = true;
      this.router.navigateByUrl('/orderDetails'); 
    }
  }

}
